import React from 'react';
import { Keyboard } from 'lucide-react';

interface KeypressVisualizerProps {
  showKeys: boolean;
  keystrokesEnabled: boolean;
  lastKeys: string;
}

export const KeypressVisualizer: React.FC<KeypressVisualizerProps> = ({
  showKeys,
  keystrokesEnabled,
  lastKeys
}) => {
  if (!showKeys || !keystrokesEnabled) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: 50,
      left: '50%',
      transform: 'translateX(-50%)',
      background: 'rgba(15, 23, 42, 0.95)',
      border: '1.5px solid #38bdf8',
      borderRadius: 8,
      padding: '10px 20px',
      color: '#38bdf8',
      fontWeight: 700,
      fontSize: '1.1rem',
      fontFamily: 'monospace',
      boxShadow: '0 4px 20px rgba(56, 189, 248, 0.4)',
      zIndex: 99992,
      display: 'flex',
      alignItems: 'center',
      gap: 6,
      animation: 'ripple-out 0.2s ease-out'
    }}>
      <Keyboard size={18} /> <span style={{ color: '#f8fafc' }}>{lastKeys}</span>
    </div>
  );
};
